export default "__VITE_ASSET__shRl1Wug__"